<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            ref="grid"
            :expandedOptions="{
                enabled: true,
                allowExpandingAll: true,
                template: 'lapidus-transactions',
            }"
        ></dx-grid>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Lapidus Residents",

        processing: false,

        lapidus: {
            transactionDialog: false,
            useType: "",
            total: 0,
            id: 0,
            rowClicked: "",
            note: "",
        },

        rules: {
            required: (value) => !!value || "Required",
        },

        columns: [
            {
                field: "accountID",
                label: "Account ID",
                //link: "LapidusAccountView",
                format: "",
                //template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "name",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "nameH",
                label: "Hebrew Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "bungalow",
                label: "Bungalow",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "quantity",
                label: "Rooms",
                format: "",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "balance",
                label: "Cheider Balance",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "dayCampBalance",
                label: "Day Camp Balance",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "total",
                label: "Lapidus Charges",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "used",
                label: "Used",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "available",
                label: "Available",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],
        useTypes: ["Cheider", "Day Camp"],

        regID: "",
        url: "",
    }),
    async created() {},
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms.map((t) => t.term),
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.actions.push({
                text: "Add Family",
                action: this.addResidents,
            });

            this.url = "lapidusTransactions?regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/lapidusDayCamp/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/lapidusDayCamp/getRegTerms");
        },
        makePayment() {
            this.$router.push({
                name: "LapidusAccountView",
                params: {
                    id: this.lapidus.rowClicked.accountID,
                    reg_id: this.lapidus.rowClicked.regID,
                },
                query: {
                    voucherPayment: true,
                },
            });
        },
        onTermSelected(value) {
            this.regID = value;
            this.url = "lapidusTransactions?regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        async saveTransaction() {
            if (!this.$refs.lapidusTotal.validate(true)) return;

            if (this.lapidus.total > this.lapidus.rowClicked.available) {
                this.$notify({
                    text:
                        "Only $" +
                        this.lapidus.rowClicked.available +
                        " is available to use. please change the amount",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            try {
                this.processing = true;

                const today = moment().format("YYYY-MM-DD HH:mm:ss");
                const year = this.regID.substring(2);

                await this.$http.post(
                    "api/lapidusDayCamp/saveLapidusTransaction",
                    {
                        accountID: this.lapidus.rowClicked.accountID,
                        type: "Used",
                        year: year,
                        date: today,
                        usedType: this.lapidus.useType,
                        note: this.lapidus.note,
                        byUser: this.$store.state.authentication.user,
                        total: this.lapidus.total,
                    }
                );

                this.processing = false;
                this.lapidus.transactionDialog = false;
                this.$refs.grid.reloadGrid();

                //this.printVoucher();
            } catch (e) {
                this.processing = false;
            }
        },
        printVoucher() {
            const newWindow = window.open(
                "",
                "Receipt",
                "width=800, height=800"
            );

            newWindow.document.write(this.createVoucher());
        },
        createVoucher() {
            let html = `<!DOCTYPE html>
                <html style="margin: 10px; padding: 10px; border-style: solid;">
                <head>
                <style>
                table {
                  font-family: arial, sans-serif;
                  border-collapse: collapse;
                }

                td, th {
                  padding: 6px;
                }
                .no-border td, th {
                    border: none;
                }
                .account-info {
                    font-family: arial, sans-serif;
                    text-align: left;
                }
                .regular-text {
                    margin-bottom: 5px;
                    margin-top: 0px;
                }
                .title {
                    font-size: 25px;
                }
                </style>
                </head>
                <body>
                <p class="regular-text" style="text-align: center;"><span style="font-size: 13pt;"><strong><span style="font-family: arial, helvetica, sans-serif;">ת"ת תורה ויראה דרבינו יואל מ'סאטמאר</span> </strong></span></p>
                            <p class="regular-text" style="text-align: center;"><span style="font-size: 11pt;"><span style="font-family: arial, helvetica, sans-serif;">שע"י סאטמאר באנגעלאו קאלאני</span></span></p>
                            <p>&nbsp;</p>

                <p style="text-align: center;" class="account-info title"><strong>Day Camp Voucher</strong></p>

                <p style="text-align: right;" class="account-info"><strong>${moment().format(
                    "L"
                )}</strong></p>

                <div class="account-info">
                <p class="regular-text"><strong>${
                    this.lapidus.rowClicked.name
                }</strong></p>
                <p class="regular-text"><strong>Address: </strong>${
                    this.lapidus.rowClicked.nameH
                }</p>`;

            html += `<table class="no-border" align="right" style="width: 35%;" border="1">
                    <tbody>

                    <td>Amount</td>
                    <td style="text-align: right;"><strong>$${
                        this.lapidus.total
                    }</strong></td>
                    </tr>
                    </tbody>
                    </table>
                    </body>
                </html>`;

            return html;
        },
        addResidents() {
            this.$router.push({
                name: "LapidusResidentsSetup",
            });
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
</style>
